export const BRIGHTPEARL_CONFIG = {
  ROW_ID: "deskeraCode",
  IS_PO_ENABLED: "SyncPoDeskeraToBrightpearl",
};
